import { render, staticRenderFns } from "./EhsList.vue?vue&type=template&id=3b2562fc"
import script from "./EhsList.vue?vue&type=script&lang=js"
export * from "./EhsList.vue?vue&type=script&lang=js"
import style0 from "./EhsList.vue?vue&type=style&index=0&id=3b2562fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports